// (function($){
//     'use strict';
//
//
//     // Find the filters div and create a select for each
//     $('.results--types').each(function() {
//
//         var $type = $(this);
//
//         var $mySelect = $('<select />');
//         var $myLabel = $('<label />');
//
//
//         // Create the dropdown base
//         $mySelect
//             .appendTo('#typesSelect')
//             .addClass('tablet-hide types__select styled')
//             .attr('id','searchType')
//             .attr('title','Search Type');
//
//         // Label
//         $myLabel
//             .attr('for',$mySelect.attr('id'))
//             .addClass('visuallyhidden')
//             .html('Search Type')
//             .insertBefore($mySelect);
//
//         // Populate dropdown with menu items
//         $type.find('.results--type').each(function() {
//             var el = $(this);
//             $('<option />', {
//                 'value': el.attr('href'),
//                 'text':  el.text().toUpperCase().replace('RESULT COUNT', '')
//             }).appendTo($mySelect);
//
//         });
//
//     });
//
//
//     $('.show-filters').click(function() {
//         $('.breadcrumbs').hide();
//         $('<h2 class="filter_h2">Filters</h2>').insertAfter($('.header__logo').hide());
//         $('.icon-tools__filter').show();
//         $('.icon-tools__standard').hide();
//         $('.filter__panel').toggleClass('open');
//         $(window).scrollTop(0);
//     });
//
//     $('.icon-tools__filter a').on('click', function() {
//         $('.breadcrumbs').show();
//         $('.header__logo').show();
//         $('.filter_h2').hide();
//         $('.icon-tools__filter').hide();
//         $('.icon-tools__standard').show();
//         $('.filter__panel').toggleClass('open');
//     });
//
//
//     function makeFacetsAccordion() {
//
//         $('div.facet ul').each( function() {
//             $(this).find('li').first().show();
//             $(this).children('li:gt(0)').hide();
//         });
//
//         $('.search-toggle-more-categories').hide();
//
//         $('.search-toggle-all-categories').each( function() {
//             $(this).unbind().bind('click', function() {
//                 if ($(this).attr('data-state') === 'expand') {
//                     $(this).attr('data-state', 'collapse');
//                     $(this).parent().parent().find('li:gt(1)').slideDown();
//                     $(this).find('span').removeClass('icon-chevron-down').addClass('icon-chevron-up');
//                 } else {
//                     $(this).attr('data-state', 'expand');
//                     $(this).parent().parent().find('li:gt(1)').slideUp();
//                     $(this).find('span').removeClass('icon-chevron-up').addClass('icon-chevron-down');
//                 }
//
//             });
//         });
//     }
//
//     function makeFacetsList(displayedCategories) {
//         $('div.facet ul').each( function() {
//             $(this).find('li').show(); //show all
//             $(this).find('li').first().hide();
//             $(this).children('li:gt('+displayedCategories+')').hide();
//         });
//
//         if ($('.facet.hidden').length) {
//             $('.more--facets').unbind().bind( 'click', function(e) {
//                 e.preventDefault();
//
//                 if ($(this).attr('data-state') === 'less') {
//                     $(this).attr('data-state', 'more');
//                     $('.facet.tohide').addClass('hidden').removeClass('tohide');
//                     $(this).find('span').text($(this).attr('data-more'));
//
//                 } else {
//                     $(this).attr('data-state', 'less');
//                     $('.facet.hidden').removeClass('hidden').addClass('tohide');
//                     $(this).find('span').text($(this).attr('data-less'));
//                 }
//                 //
//             });
//         } else {
//             $('.more--facets').hide();
//         }
//
//         $('.search-toggle-more-categories').each( function() {
//             var nbCategories = $(this).parent().parent().find('li').size();
//
//             if ( nbCategories <= displayedCategories ) {
//                 $(this).hide();
//             } else {
//                 $(this).show();
//                 $(this).unbind().bind( 'click', function() {
//                     if ($(this).attr('data-state') === 'less') {
//                         $(this).attr('data-state', 'more');
//                         $(this).parent().parent().find('li:gt('+(displayedCategories-1)+')').slideUp();
//                         $(this).find('span').text($(this).attr('data-more'));
//                         $(this).removeClass('is-expanded');
//                         $(this).text('MORE');
//                     } else {
//                         $(this).attr('data-state', 'less');
//                         $(this).parent().parent().find('li:gt('+(displayedCategories-1)+')').slideDown();
//                         $(this).find('span').text($(this).attr('data-less'));
//                         $(this).addClass('is-expanded');
//                         $(this).text('LESS');
//                     }
//                 });
//             }
//         });
//
//     }
//
//
//     $(window).on('load resize', function() {
//
//         if ($('body').width() + 30 > 768) {
//             $('.icon-tools__filter a').trigger('click');
//             makeFacetsList(5);
//         } else {
//             makeFacetsAccordion();
//         }
//
//     });
//
// }(jQuery));